import React, {Component, ReactNode} from "react"

import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import GenericModal from "@irati/ui/src/GenericModal"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"

interface Props extends InjectIntl {
  title: string
  proceedButtonText: string
  selectedEmployees: any
  show: boolean
  submit?: Promise<any> | null
  onConfirm: () => void
  onHide: () => void
  children: ReactNode
}

interface State {
  showSelectedPeople: boolean
}

class MoveUsersModal extends Component<Props, State> {
  state: State = {
    showSelectedPeople: false
  }

  handleViewSelectedPeople = () => {
    this.setState((prevState: State) => ({
      showSelectedPeople: !prevState.showSelectedPeople
    }))
  }

  render() {
    const {formatMessage, title, proceedButtonText, selectedEmployees, show, submit, onConfirm, onHide, children} = this.props
    const {showSelectedPeople} = this.state

    return (
      <GenericModal
        dismissButtonId="adminSection_people_modal_dismiss_button"
        show={show}
        title={formatMessage({id: title})}
        load={submit}
        proceedButtonText={formatMessage({id: proceedButtonText}, {employees: selectedEmployees.length})}
        onConfirm={onConfirm}
        onHide={onHide}>
        <Body large maxWidth="100%" marginBottom={2}>
          {formatMessage({id: "admin.components.manageUsersPopUp.moveTeamPopup.para"}, {employees: selectedEmployees.length})}
        </Body>
        <Body marginBottom={2}>
          <Flex alignItems="center">
            <Button tertiary onClick={this.handleViewSelectedPeople}>
              <Body small marginRight={1}>
                <FormattedMessage id="admin.components.manageUsersPopUp.moveTeamPopup.users" />
              </Body>
              <Icon icon={showSelectedPeople ? IconTypes.chevronUp : IconTypes.chevronDown} />
            </Button>
          </Flex>
          {showSelectedPeople &&
            selectedEmployees.map((selectedEmployee) => (
              <Body marginTop={2}>
                <Body small marginBottom={1}>
                  {selectedEmployee.firstName} {selectedEmployee.lastName}
                </Body>
              </Body>
            ))}
        </Body>
        {children}
      </GenericModal>
    )
  }
}

export default injectIntl(MoveUsersModal)
